import {navigationAPI} from "~/api/navigationAPI";
import {TagAuth} from "~/constants/Tags";

export const enhancedNavigationAPI = navigationAPI.enhanceEndpoints({
    addTagTypes: [TagAuth],
    endpoints: {
        getNavigationMenus: {providesTags: () => [{type: TagAuth, id: "current"}]},
        getNavigationMenusByMenuName: {
            providesTags: (res) => {
                return res && res["auth-dependent"]  ? [{type: TagAuth, id: "current"}] : [];
            }
        }
    }
});

export const {
    useGetNavigationDataQuery,
    useLazyGetNavigationDataQuery,
    useGetNavigationMenusQuery,
    useLazyGetNavigationMenusQuery,
    useGetNavigationMenusByMenuNameQuery,
    useLazyGetNavigationMenusByMenuNameQuery,
} = enhancedNavigationAPI;